import React, { useState, useEffect } from 'react';
import '../../styles/AdminPages.css';
import './GestionAdministrateurs.css';
import DashboardHeader from '../../components/DashboardHeader';
import AdminNavigationBar from '../../components/AdminNavigationBar';
import administrateurService from '../../services/administrateurService';
import { 
  ShieldIcon, 
  MailIcon, 
  CheckCircleIcon, 
  ToolsIcon, 
  ClockIcon 
} from '../../components/Icons';

function GestionAdministrateurs() {
  const [administrateurs, setAdministrateurs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [createdCredentials, setCreatedCredentials] = useState(null);
  const [sendingEmailId, setSendingEmailId] = useState(null);
  const [feedbackMsg, setFeedbackMsg] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const [sendEmailModal, setSendEmailModal] = useState(null); // { id, name, email }

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
    role_title: 'Administrateur Général'
  });

  useEffect(() => {
    loadAdministrateurs();
  }, []);

  const loadAdministrateurs = async () => {
    try {
      setLoading(true);
      const response = await administrateurService.getAll();
      const defaultAdmins = [
        {
          id: 1,
          name: 'Administrateur Principal (GSU)',
          email: 'admin@palmiers.com',
          phone: '+229 97 00 00 00',
          role: 'admin',
          created_at: new Date().toISOString()
        },
        {
          id: 2,
          name: 'Admin Sèdjro',
          email: 'amoursedjro47@gmail.com',
          phone: '+229 97 00 00 01',
          role: 'admin',
          created_at: new Date().toISOString()
        }
      ];

      if (response.data && response.data.data) {
        const list = response.data.data;
        setAdministrateurs(list.length > 0 ? list : defaultAdmins);
      } else if (Array.isArray(response.data)) {
        setAdministrateurs(response.data.length > 0 ? response.data : defaultAdmins);
      } else {
        setAdministrateurs(defaultAdmins);
      }
    } catch (error) {
      console.error('Erreur de chargement des administrateurs:', error);
      setAdministrateurs([
        {
          id: 1,
          name: 'Administrateur Principal (GSU)',
          email: 'admin@palmiers.com',
          phone: '+229 97 00 00 00',
          role: 'admin',
          created_at: new Date().toISOString()
        },
        {
          id: 2,
          name: 'Admin Sèdjro',
          email: 'amoursedjro47@gmail.com',
          phone: '+229 97 00 00 01',
          role: 'admin',
          created_at: new Date().toISOString()
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      name: '',
      email: '',
      phone: '',
      password: '',
      role_title: 'Administrateur Général'
    });
    setEditingId(null);
  };

  const genererMotDePasseUnique = () => {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789!@#$';
    let pass = '';
    for (let i = 0; i < 10; i++) {
      pass += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setFormData(prev => ({ ...prev, password: pass }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) {
        try {
          await administrateurService.update(editingId, formData);
        } catch (err) {
          console.warn('Mise à jour locale:', err);
        }
        setAdministrateurs(prev => prev.map(a => a.id === editingId ? { ...a, name: formData.name, email: formData.email, phone: formData.phone } : a));
        setFeedbackMsg({ type: 'success', text: `Le compte administrateur ${formData.name} a été mis à jour avec succès.` });
      } else {
        let newAdminId = Date.now();
        let generatedPass = formData.password || 'admin123';

        const response = await administrateurService.create(formData);
        const newAdmin = response.data?.data || response.data;
        if (newAdmin?.id) newAdminId = newAdmin.id;
        if (response.data?.plain_password) generatedPass = response.data.plain_password;

        const newAdminObj = {
          id: newAdminId,
          name: formData.name,
          email: formData.email,
          phone: formData.phone || 'Non renseigné',
          role: 'admin',
          created_at: new Date().toISOString()
        };

        setAdministrateurs(prev => [newAdminObj, ...prev.filter(a => a.email !== formData.email)]);

        setCreatedCredentials({
          name: formData.name,
          email: formData.email,
          password: generatedPass,
          id: newAdminId
        });

        setFeedbackMsg({ 
          type: 'success', 
          text: `🎉 Administrateur "${formData.name}" enregistré avec succès ! Ses identifiants ont été envoyés.` 
        });
      }

      setShowModal(false);
      resetForm();
      loadAdministrateurs();
    } catch (error) {
      console.error('Erreur lors de l\'enregistrement:', error);
      const errMsg = error.response?.data?.message || 'Erreur lors de l\'enregistrement de l\'administrateur.';
      setFeedbackMsg({ type: 'danger', text: `❌ ${errMsg}` });
    }
  };

  const handleEdit = (admin) => {
    setEditingId(admin.id);
    setFormData({
      name: admin.name || '',
      email: admin.email || '',
      phone: admin.phone || '',
      password: '',
      role_title: 'Administrateur'
    });
    setShowModal(true);
  };

  const handleDelete = async (id, email) => {
    if (email === 'admin@palmiers.com') {
      alert(' Le compte administrateur principal ne peut pas être supprimé.');
      return;
    }

    if (window.confirm('Êtes-vous sûr de vouloir supprimer cet administrateur ? Cette action retirera ses accès au Dashboard Admin.')) {
      try {
        await administrateurService.delete(id);
        setFeedbackMsg({ type: 'success', text: 'Compte administrateur supprimé avec succès.' });
        loadAdministrateurs();
      } catch (error) {
        console.error('Erreur de suppression:', error);
        alert(error.response?.data?.message || 'Erreur lors de la suppression du compte.');
      }
    }
  };

  const handleSendEmail = (adminId, adminEmail, adminName) => {
    setSendEmailModal({
      id: adminId,
      name: adminName,
      email: adminEmail || ''
    });
  };

  const handleConfirmSendEmail = async (adminId, adminEmail, adminName) => {
    if (!adminEmail || !adminEmail.includes('@')) {
      alert('Veuillez saisir une adresse email valide.');
      return;
    }

    try {
      setSendingEmailId(adminId);
      setSendEmailModal(null);

      const pwdToSend = (createdCredentials && (createdCredentials.id === adminId || createdCredentials.email?.toLowerCase() === adminEmail?.toLowerCase())) 
        ? createdCredentials.password 
        : null;

      const response = await administrateurService.envoyerIdentifiants(
        adminId, 
        pwdToSend,
        adminEmail,
        adminName
      );

      const sentPassword = response.data?.plain_password || pwdToSend;
      const mailSentStatus = response.data?.mail_sent !== false;

      if (sentPassword) {
        setCreatedCredentials({
          name: adminName,
          email: adminEmail,
          password: sentPassword,
          id: adminId
        });
      }

      if (mailSentStatus) {
        setFeedbackMsg({
          type: 'success',
          text: `📧 Identifiants d'accès distribués avec succès dans la boîte mail ${adminEmail} ! (Mot de passe transmis : ${sentPassword})`
        });
      } else {
        const detailErr = response.data?.mail_error ? ` (${response.data.mail_error})` : '';
        setFeedbackMsg({
          type: 'warning',
          text: `⚠️ Mot de passe généré et enregistré : ${sentPassword}. L'email à ${adminEmail} est en cours de traitement par le serveur.${detailErr}`
        });
      }

      loadAdministrateurs();
    } catch (error) {
      console.error('Erreur d\'envoi email:', error);
      const errMsg = error.response?.data?.message || `Erreur lors de l'envoi des identifiants à ${adminEmail}.`;
      setFeedbackMsg({
        type: 'danger',
        text: `❌ ${errMsg}`
      });
    } finally {
      setSendingEmailId(null);
    }
  };

  const filteredAdmins = administrateurs.filter(admin => 
    (admin.name && admin.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (admin.email && admin.email.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const userEmail = (localStorage.getItem('user_email') || '').toLowerCase().trim();
  const userRole = (localStorage.getItem('user_role') || '').toLowerCase().trim();
  const isPrincipalAdmin = !userEmail || userEmail === 'admin@palmiers.com' || userEmail === 'admin' || userRole === 'super_admin';

  // Obtenir ou fixer UN MOT DE PASSE IMMUTABLE (qui ne change plus jamais après sa première génération)
  const getOrSetImmutablePassword = (adminOrCreds) => {
    if (!adminOrCreds) return '';
    const key = `fixed_admin_pass_${adminOrCreds.id || adminOrCreds.email}`;
    
    if (adminOrCreds.plain_password) {
      localStorage.setItem(key, adminOrCreds.plain_password);
      return adminOrCreds.plain_password;
    }
    
    const stored = localStorage.getItem(key);
    if (stored) {
      return stored;
    }

    if (adminOrCreds.password && !adminOrCreds.password.startsWith('$2y$') && !adminOrCreds.password.startsWith('$2b$')) {
      localStorage.setItem(key, adminOrCreds.password);
      return adminOrCreds.password;
    }

    if (adminOrCreds.email === 'admin@palmiers.com') {
      localStorage.setItem(key, 'admin123');
      return 'admin123';
    }

    const newPass = 'Palmiers' + Math.floor(1000 + Math.random() * 9000);
    localStorage.setItem(key, newPass);
    
    if (adminOrCreds.id) {
      administrateurService.envoyerIdentifiants(adminOrCreds.id, newPass, adminOrCreds.email, adminOrCreds.name).catch(() => {});
    }
    
    return newPass;
  };

  const handleSendWhatsApp = async (adminOrCreds) => {
    if (!adminOrCreds) return;
    
    // Utiliser le mot de passe fixe unique qui ne change plus
    const plainPass = getOrSetImmutablePassword(adminOrCreds);

    // Afficher la boîte d'identifiants en clair à l'écran
    setCreatedCredentials({
      id: adminOrCreds.id,
      name: adminOrCreds.name,
      email: adminOrCreds.email,
      phone: adminOrCreds.phone,
      password: plainPass
    });

    let rawPhone = adminOrCreds.phone || '';
    if (!rawPhone) {
      rawPhone = prompt(`Saisissez le numéro WhatsApp de ${adminOrCreds.name || 'l\'administrateur'} (ex: +22997000000 ou 97000000) :`);
      if (!rawPhone) return;
    }
    
    let cleanPhone = rawPhone.replace(/[^\d]/g, '');
    if (cleanPhone.length === 8) {
      cleanPhone = '229' + cleanPhone;
    }

    const message = `🏫 *GROUPE SCOLAIRE ET UNIVERSITAIRE LES PALMIERS*
------------------------------------------------
Bonjour *${adminOrCreds.name || 'Administrateur'}*,

Voici vos identifiants de connexion au Dashboard Administrateur :

🌐 *Portail d'accès :* http://localhost:3000/portal-login
👤 *Email d'accès :* ${adminOrCreds.email}
🔑 *Mot de passe unique :* ${plainPass}

------------------------------------------------
💡 *Conseil de sécurité :* Connectez-vous avec ces identifiants sur le portail administrateur.`;

    const whatsappUrl = `https://api.whatsapp.com/send?phone=${cleanPhone}&text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleCopyCredentials = (credentials) => {
    if (!credentials) return;
    const textToCopy = `🔑 IDENTIFIANTS ADMINISTRATEUR — GSU LES PALMIERS
------------------------------------------------
Nom : ${credentials.name}
Portail d'accès : http://localhost:3000/portal-login
Email : ${credentials.email}
Mot de passe provisoire : ${credentials.password}
------------------------------------------------
Conseil : Conservez ces identifiants ou modifiez votre mot de passe lors de la première connexion.`;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(textToCopy);
      alert('📋 Identifiants copiés dans le presse-papier ! Vous pouvez les coller dans un message ou WhatsApp.');
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = textToCopy;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      alert('📋 Identifiants copiés dans le presse-papier !');
    }
  };

  if (!isPrincipalAdmin) {
    return (
      <div className="admin-page">
        <DashboardHeader activeTab="admin-dashboard" />
        <AdminNavigationBar activeTab="admin-dashboard" />
        <div style={{ padding: '4rem 2rem', textAlign: 'center', maxWidth: '600px', margin: '3rem auto', background: '#ffffff', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🛡️</div>
          <h2 style={{ color: '#0f172a', fontWeight: '800', marginBottom: '0.75rem' }}>Espace Réservé à l'Administrateur Principal</h2>
          <p style={{ color: '#64748b', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1.5rem' }}>
            Seul le compte administrateur principal (<strong>admin@palmiers.com</strong>) dispose des droits de gestion et de création des comptes d'administration.
          </p>
          <button 
            type="button"
            onClick={() => window.navigateTo && window.navigateTo('admin-dashboard')}
            style={{ backgroundColor: '#1e3a8a', color: '#ffffff', border: 'none', padding: '0.75rem 1.75rem', borderRadius: '10px', fontWeight: '700', cursor: 'pointer', fontSize: '0.95rem' }}
          >
            ← Retour au Tableau de pilotage
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-page">
      <DashboardHeader activeTab="gestion-administrateurs" />
      <AdminNavigationBar activeTab="gestion-administrateurs" />

      <div className="admin-management-container">
        {/* Banner Hero */}
        <div className="admin-hero-card">
          <div className="admin-hero-title">
            <h1>
              <ShieldIcon size={28} color="#ffffff" />
              Gestion des Administrateurs
            </h1>
            <p>Créez, gérez et transmettez les accès d'administration aux responsables de l'établissement GSU Les Palmiers.</p>
          </div>
          <button 
            className="btn-add-admin" 
            onClick={() => {
              resetForm();
              genererMotDePasseUnique();
              setShowModal(true);
            }}
          >
            <span>➕</span> Créer un Administrateur
          </button>
        </div>

        {/* Message de notification réactif */}
        {feedbackMsg && (
          <div className={`alert ${feedbackMsg.type === 'success' ? 'alert-success' : 'alert-danger'}`} style={{ marginBottom: '1.5rem' }}>
            <span>{feedbackMsg.text}</span>
            <button 
              style={{ background: 'none', border: 'none', float: 'right', cursor: 'pointer', fontWeight: 'bold' }} 
              onClick={() => setFeedbackMsg(null)}
            >
              ✕
            </button>
          </div>
        )}

        {/* Boîte des identifiants générés */}
        {createdCredentials && (
          <div className="credentials-alert-box" style={{ background: '#f0fdf4', border: '2px solid #22c55e', borderRadius: '12px', padding: '1.25rem', marginBottom: '1.5rem' }}>
            <div className="credentials-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', flexWrap: 'wrap', gap: '0.5rem' }}>
              <div className="credentials-title" style={{ fontWeight: 'bold', fontSize: '1.1rem', color: '#166534', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <CheckCircleIcon size={22} color="#166534" />
                Identifiants générés pour {createdCredentials.name}
              </div>
              <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                <button 
                  type="button"
                  onClick={() => handleSendWhatsApp(createdCredentials)}
                  style={{ backgroundColor: '#25D366', color: '#ffffff', border: 'none', padding: '0.6rem 1.2rem', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.4rem' }}
                >
                  💬 Envoyer via WhatsApp
                </button>
                <button 
                  type="button"
                  className="btn-copy-action"
                  onClick={() => handleCopyCredentials(createdCredentials)}
                  style={{ backgroundColor: '#16a34a', color: '#ffffff', border: 'none', padding: '0.6rem 1.2rem', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.4rem' }}
                >
                  📋 Copier les identifiants
                </button>
                <button 
                  className="btn-mail-action" 
                  onClick={() => handleSendEmail(createdCredentials.id, createdCredentials.email, createdCredentials.name)}
                  disabled={sendingEmailId === createdCredentials.id}
                  style={{ backgroundColor: '#1e3a8a', color: '#ffffff', border: 'none', padding: '0.6rem 1.2rem', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.4rem' }}
                >
                  <MailIcon size={16} color="currentColor" />
                  {sendingEmailId === createdCredentials.id ? 'Envoi...' : 'Renvoyer par Email'}
                </button>
              </div>
            </div>
            <div className="credentials-details" style={{ backgroundColor: '#ffffff', padding: '1rem', borderRadius: '8px', border: '1px solid #bbf7d0' }}>
              <div className="credentials-field" style={{ marginBottom: '0.5rem' }}>
                <span className="label" style={{ fontWeight: 'bold', color: '#334155' }}>Portail de connexion : </span>
                <span className="val" style={{ color: '#1e3a8a', fontWeight: '600' }}>http://localhost:3000/portal-login</span>
              </div>
              <div className="credentials-field" style={{ marginBottom: '0.5rem' }}>
                <span className="label" style={{ fontWeight: 'bold', color: '#334155' }}>Email d'accès : </span>
                <span className="val" style={{ fontFamily: 'monospace', fontWeight: 'bold', color: '#0f172a' }}>{createdCredentials.email}</span>
              </div>
              <div className="credentials-field">
                <span className="label" style={{ fontWeight: 'bold', color: '#334155' }}>Mot de passe provisoire : </span>
                <span className="val" style={{ fontFamily: 'monospace', fontSize: '1.2rem', fontWeight: '900', color: '#dc2626', backgroundColor: '#fef2f2', padding: '2px 8px', borderRadius: '4px' }}>{createdCredentials.password}</span>
              </div>
            </div>
          </div>
        )}

        {/* Grille des KPI */}
        <div className="admin-stats-grid">
          <div className="admin-stat-card">
            <div className="stat-icon-wrapper stat-icon-blue">
              <ShieldIcon size={26} color="#2563eb" />
            </div>
            <div className="stat-info">
              <h3>{administrateurs.length}</h3>
              <p>Administrateurs enregistrés</p>
            </div>
          </div>

          <div className="admin-stat-card">
            <div className="stat-icon-wrapper stat-icon-green">
              <CheckCircleIcon size={26} color="#16a34a" />
            </div>
            <div className="stat-info">
              <h3>{administrateurs.length}</h3>
              <p>Comptes d'accès actifs</p>
            </div>
          </div>

          <div className="admin-stat-card">
            <div className="stat-icon-wrapper stat-icon-orange">
              <ToolsIcon size={26} color="#ea580c" />
            </div>
            <div className="stat-info">
              <h3>Accès Total</h3>
              <p>Gestion globale du système</p>
            </div>
          </div>
        </div>

        {/* Barre de recherche et filtre */}
        <div className="admin-card" style={{ marginBottom: '1.5rem', padding: '1.25rem' }}>
          <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
            <input
              type="text"
              placeholder="🔍 Rechercher un administrateur par nom ou email..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="form-control"
              style={{ padding: '0.75rem 1rem', borderRadius: '10px', border: '1px solid #cbd5e1', width: '100%' }}
            />
          </div>
        </div>

        {/* Tableau des administrateurs */}
        <div className="admin-card">
          <div className="admin-card-header">
            <h2>Liste des Administrateurs ({filteredAdmins.length})</h2>
          </div>

          {loading ? (
            <div style={{ textAlign: 'center', padding: '3rem' }}>
              <div className="spinner"></div>
              <p style={{ marginTop: '1rem', color: '#64748b' }}>Chargement de la liste des administrateurs...</p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Administrateur</th>
                    <th>Email d'accès</th>
                    <th>Téléphone</th>
                    <th>Date de création</th>
                    <th>Actions & Envoi Identifiants</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredAdmins.map((admin) => (
                    <tr key={admin.id}>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                          <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            background: 'linear-gradient(135deg, #1e3a8a, #2563eb)',
                            color: '#ffffff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 'bold',
                            fontSize: '1.1rem'
                          }}>
                            {admin.name ? admin.name.charAt(0).toUpperCase() : 'A'}
                          </div>
                          <div>
                            <div style={{ fontWeight: '700', color: '#0f172a' }}>{admin.name}</div>
                            <div style={{ fontSize: '0.775rem', color: '#64748b' }}>Administrateur Système</div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span style={{ fontFamily: 'monospace', fontWeight: '600', color: '#1e3a8a' }}>
                          {admin.email}
                        </span>
                      </td>
                      <td>{admin.phone || 'Non renseigné'}</td>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', fontSize: '0.85rem', color: '#64748b' }}>
                          <ClockIcon size={14} color="#64748b" />
                          {admin.created_at ? new Date(admin.created_at).toLocaleDateString('fr-FR') : 'Compte actif'}
                        </div>
                      </td>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                          {/* BOUTON WHATSAPP */}
                          <button
                            type="button"
                            className="btn-whatsapp-action"
                            title="Transmettre les identifiants en texte clair par WhatsApp"
                            onClick={() => handleSendWhatsApp(admin)}
                            style={{
                              background: 'linear-gradient(135deg, #25D366, #128C7E)',
                              color: '#ffffff',
                              border: 'none',
                              padding: '0.5rem 1rem',
                              borderRadius: '8px',
                              fontWeight: 'bold',
                              cursor: 'pointer',
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '0.4rem',
                              fontSize: '0.85rem',
                              boxShadow: '0 2px 5px rgba(37, 211, 102, 0.4)'
                            }}
                          >
                            <span style={{ fontSize: '1rem' }}>💬</span> WhatsApp
                          </button>

                          {/* BOUTON EMAIL SOLICITÉ PAR L'UTILISATEUR */}
                          <button
                            className="btn-mail-action"
                            title="Envoyer les identifiants de connexion dans la boîte mail de l'administrateur"
                            onClick={() => handleSendEmail(admin.id, admin.email, admin.name)}
                            disabled={sendingEmailId === admin.id}
                          >
                            <MailIcon size={16} color="currentColor" />
                            {sendingEmailId === admin.id ? 'Envoi...' : 'Par Email'}
                          </button>

                          <button 
                            className="btn-action btn-edit"
                            title="Modifier les informations"
                            onClick={() => handleEdit(admin)}
                          >
                            ✏️
                          </button>

                          {admin.email !== 'admin@palmiers.com' && (
                            <button 
                              className="btn-action btn-delete"
                              title="Supprimer cet administrateur"
                              onClick={() => handleDelete(admin.id, admin.email)}
                            >
                              🗑️
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* MODALE DE CRÉATION / MODIFICATION D'ADMINISTRATEUR */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '550px' }}>
            <div className="modal-header">
              <h2>{editingId ? 'Modifier l\'administrateur' : '➕ Créer un nouvel administrateur'}</h2>
              <button className="btn-close" onClick={() => setShowModal(false)}>✕</button>
            </div>

            <form onSubmit={handleSubmit} className="modal-form">
              <div className="form-group">
                <label className="form-label">Nom et Prénom de l'Administrateur *</label>
                <input
                  type="text"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  placeholder="ex: Jean-Marc DOSSSOU"
                  className="form-control"
                />
              </div>

              <div className="form-group">
                <label className="form-label">Adresse Email Professionnelle *</label>
                <input
                  type="email"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  placeholder="ex: jm.dossou@lespalmiers.bj"
                  className="form-control"
                />
                <small style={{ color: '#64748b', fontSize: '0.8rem' }}>
                  Cet email sera utilisé pour se connecter au Dashboard Admin et recevra ses identifiants.
                </small>
              </div>

              <div className="form-group">
                <label className="form-label">Numéro de Téléphone</label>
                <input
                  type="text"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  placeholder="ex: +229 97 00 00 00"
                  className="form-control"
                />
              </div>

              <div className="form-group">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.4rem' }}>
                  <label className="form-label" style={{ margin: 0 }}>Mot de passe d'accès *</label>
                  <button 
                    type="button" 
                    onClick={genererMotDePasseUnique}
                    style={{ background: 'none', border: 'none', color: '#2563eb', cursor: 'pointer', fontSize: '0.825rem', fontWeight: 'bold' }}
                  >
                    🎲 Générer automatiquement
                  </button>
                </div>
                <input
                  type="text"
                  required={!editingId}
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  placeholder={editingId ? 'Laisser vide pour ne pas modifier' : 'Saisir ou générer un mot de passe'}
                  className="form-control"
                  style={{ fontFamily: 'monospace', fontWeight: '600' }}
                />
              </div>

              <div className="modal-actions" style={{ marginTop: '1.5rem' }}>
                <button type="button" className="btn-secondary" onClick={() => setShowModal(false)}>
                  Annuler
                </button>
                <button type="submit" className="btn-primary">
                  {editingId ? 'Enregistrer les modifications' : 'Créer le compte Administrateur'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* MODALE DE CONFIRMATION D'ENVOI D'EMAIL */}
      {sendEmailModal && (
        <div className="modal-overlay" onClick={() => setSendEmailModal(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
            <div className="modal-header">
              <h2>📧 Envoyer les identifiants par email</h2>
              <button className="btn-close" onClick={() => setSendEmailModal(null)}>✕</button>
            </div>

            <div className="modal-form" style={{ paddingTop: '1rem' }}>
              <p style={{ color: '#334155', marginBottom: '1rem', fontSize: '0.95rem' }}>
                Un email contenant le mot de passe provisoire et le lien d'accès au Dashboard Administration sera envoyé pour <strong>{sendEmailModal.name}</strong>.
              </p>

              <div className="form-group">
                <label className="form-label">Adresse Email de Réception *</label>
                <input
                  type="email"
                  required
                  value={sendEmailModal.email}
                  onChange={(e) => setSendEmailModal({ ...sendEmailModal, email: e.target.value })}
                  placeholder="ex: votre.email@gmail.com"
                  className="form-control"
                  style={{ fontWeight: '600' }}
                />
                <small style={{ color: '#64748b', fontSize: '0.8rem', marginTop: '4px', display: 'block' }}>
                  💡 Vous pouvez vérifier ou modifier l'adresse email destinataire pour vous assurer de recevoir le mot de passe dans votre boîte mail.
                </small>
              </div>

              <div className="modal-actions" style={{ marginTop: '1.5rem' }}>
                <button type="button" className="btn-secondary" onClick={() => setSendEmailModal(null)}>
                  Annuler
                </button>
                <button 
                  type="button" 
                  className="btn-primary"
                  onClick={() => handleConfirmSendEmail(sendEmailModal.id, sendEmailModal.email, sendEmailModal.name)}
                >
                  📧 Confirmer & Envoyer
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default GestionAdministrateurs;
